const ERRORS = {
  AFFILIATE: {
    NOT_FOUND: 'affiliate-not-found',
  },
};

export default ERRORS;
